module.exports = __webpack_public_path__ + "img/13.df04712e.jpg";